import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { AppService } from './app.service';
import { HttpClientModule } from '@angular/common/http';
import { HomeContfilter } from './home/home.contfilter';
import { ContentmainComponent } from './contentmain/contentmain.component';
import { AccountComponent } from './account/account.component';
import { AngularWebStorageModule } from 'angular-web-storage';
import { SlideshowModule } from 'ng-simple-slideshow';
import { NgxSpinnerModule } from 'ngx-spinner';

import {
  SocialLoginModule,
  AuthServiceConfig,
  GoogleLoginProvider,
  FacebookLoginProvider,
} from 'angular-6-social-login';
import { AboutComponent } from './about/about.component';
import { FeaturedComponent } from './featured/featured.component';
import { ToollistComponent } from './toollist/toollist.component';
import {AppDatashareservice} from './app.datashareservice';
import { ThemesComponent } from './themes/themes.component';
import { SourcesComponent } from './sources/sources.component';
import { SearchappComponent } from './searchapp/searchapp.component';
import { SingleappComponent } from './singleapp/singleapp.component';
import { AppPreviousrouterservice } from './app.previousrouterservice';
import { RecentchangesComponent } from './singleapp/recentchanges/recentchanges.component';
import { AuthorComponent } from './singleapp/author/author.component';
import { InstalledComponent } from './installed/installed.component';
import { ChangesComponent } from './changes/changes.component';
import { AppsourcesComponent } from './appsources/appsources.component';
import { ModalModule } from 'angular-custom-modal';

export function getAuthServiceConfigs() {
  const config = new AuthServiceConfig(
    [
      {
        id: FacebookLoginProvider.PROVIDER_ID,
        provider: new FacebookLoginProvider('1398443943628555')
      },
      {
        id: GoogleLoginProvider.PROVIDER_ID,
        provider: new GoogleLoginProvider('579610192448-sr3c0fah4tq8khf9ldrn9344p60ti3lr.apps.googleusercontent.com')
      }
    ]);
  return config;
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HomeContfilter,
    ContentmainComponent,
    AccountComponent,
    AboutComponent,
    FeaturedComponent,
    ToollistComponent,
    ThemesComponent,
    SourcesComponent,
    SearchappComponent,
    SingleappComponent,
    RecentchangesComponent,
    AuthorComponent,
    InstalledComponent,
    ChangesComponent,
    AppsourcesComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    SocialLoginModule,
    AngularWebStorageModule,
    SlideshowModule,
    NgxSpinnerModule,
    ModalModule
  ],
  providers: [
    AppService,
    AppPreviousrouterservice,
    AppDatashareservice,
    {
      provide: AuthServiceConfig,
      useFactory: getAuthServiceConfigs
    }
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
